import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { CompanyPage } from "../CompanyPage/CompanyPage";
import { HomePage } from "../HomePage/HomePage";
import { PrivacyPolicyPage } from "../PrivacyPolicyPage/PrivacyPolicyPage";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path={`/`} element={<HomePage />} />
          <Route path={`/company`} element={<CompanyPage />} />
          <Route
            path={`/verylongstmaps/privacy-policy`}
            element={<PrivacyPolicyPage />}
          />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
